export const removeLazy = () => {
  // 商品ページのloading=lazyを除去
  const images = document.getElementsByTagName("img");
  for (let i = 0; i < images.length; i++) {
    images[i].removeAttribute("loading");
  }
};
